import UpdateAffiliateCampaignPage from "./update-affiliate-campaign.page";

export default UpdateAffiliateCampaignPage;
